import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { isNative } from "./platform";
import "./Dialog.scss";

// On native, add bottom-sheet styling to all dialogs
const nativeClass = isNative() ? {
	popup: 'bottom-sheet',
} : {};

// Create a pre-configured SweetAlert2 instance with custom defaults
const Dialog = withReactContent(
	Swal.mixin({
		buttonsStyling: false,
		customClass: {
			confirmButton: 'btn btn-primary',
			denyButton: 'btn btn-outline-secondary',
			cancelButton: 'btn btn-outline-secondary',
			...nativeClass,
		}
	})
);

export default Dialog;
